import { createFileRoute, redirect } from '@tanstack/react-router';

// Catch-all for any path that doesn't match a defined route.
export const Route = createFileRoute('/$')({
  beforeLoad: () => {
    throw redirect({ to: '/profiles' });
  },
});
